import { render, staticRenderFns } from "./ServiceCenters.vue?vue&type=template&id=205e54b8"
import script from "./ServiceCenters.vue?vue&type=script&lang=js"
export * from "./ServiceCenters.vue?vue&type=script&lang=js"
import style0 from "./ServiceCenters.vue?vue&type=style&index=0&id=205e54b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports